"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmount = void 0;
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useAmount = function (winData) {
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        var currency = ((_a = winData === null || winData === void 0 ? void 0 : winData.win) === null || _a === void 0 ? void 0 : _a[currentCurrency]) ? currentCurrency : 'EUR';
        return "".concat((0, apps_shared_1.getCurrencySymbol)(currency)).concat((_c = Math.floor(((_b = winData === null || winData === void 0 ? void 0 : winData.win) === null || _b === void 0 ? void 0 : _b[currency]) || 0)) === null || _c === void 0 ? void 0 : _c.toLocaleString('en-US'));
    }, [currentCurrency, winData]);
};
exports.useAmount = useAmount;
